import type {
  LegacyCorrectableHeader,
  LegacyReportCorrectionBody,
} from "../services/legacyReportCorrection.service";

export const LEGACY_CORRECTION_FIELDS = [
  ["patientNameText", "Printed patient display name"],
  ["patientFirstName", "Printed first name"],
  ["patientLastName", "Printed last name"],
  ["dateOfBirth", "Printed date of birth"],
  ["sex", "Printed sex"],
  ["medicalRecordNumber", "Printed medical record number"],
  ["dateCollected", "Printed collection date"],
  ["dateReceived", "Printed received date"],
  ["physicianText", "Printed physician"],
  ["laboratoryText", "Printed laboratory"],
] as const;

export interface LegacyReportCorrectionValues {
  header: Required<LegacyCorrectableHeader>;
  reason: string;
}

export function createLegacyCorrectionValues(
  header: LegacyCorrectableHeader
): LegacyReportCorrectionValues {
  return {
    reason: "",
    header: Object.fromEntries(
      LEGACY_CORRECTION_FIELDS.map(([field]) => [field, header[field] || ""])
    ) as Required<LegacyCorrectableHeader>,
  };
}

export function createLegacyCorrectionBody(
  original: LegacyCorrectableHeader,
  values: LegacyReportCorrectionValues
): LegacyReportCorrectionBody | null {
  const changes = Object.fromEntries(
    LEGACY_CORRECTION_FIELDS.filter(
      ([field]) => values.header[field] !== (original[field] || "")
    ).map(([field]) => [field, values.header[field]])
  );
  if (!Object.keys(changes).length) return null;
  return {
    reason: values.reason.trim(),
    legacyReportCorrection: { header: changes },
  };
}
